export const H3MapConfig = {
    features: {
        // H3 kullanımının etkinleştirilmesi
        isH3Enabled: true,
        // Otomatik çözünürlük seçimi
        autoResolution: false,
        // Analiz paneli görünürlüğü
        showToolsPanel: true,
        // Seçim özellikleri
        isActionsEnabled: true,
        // Sadece H3 hücrelerin çözünürlükleri
        onlyH3Resolutions: false,
        // Analiz paneli başlangıçta görünür mü
        isToolsPanelVisibleOnInitial: true,
        // Önizleme modu
        isPreview: false,
        // Diğer hexagonları gösterme özelliği
        showOtherHexagons: true,
        // Diğer hexagonları gösterme paneli görünürlüğü
        showOtherHexagonsPanel: false,
        // H3 seçimi etkinleştirme
        isH3SelectionEnabled: true,
        // Hexagon tooltip görünürlüğü
        showHexagonTooltip: false
    },
    map: {
        // Varsayılan harita ayarları
        defaultCenter: {lat: 41.0, lng: 29},
        defaultZoom: 9
    },
    // Hexagon tipleri ve stilleri
    hexagons: {
        SELECTED: {
            color: "#1a237e",
            opacity: 0.4,
            zIndex: 200
        },
        PREVIEW: {
            color: "#FFFF00",
            opacity: 0.2,
            zIndex: 250
        },
        HOVER: {
            color: "#4CAF50",
            opacity: 0.4,
            zIndex: 300
        },
        OTHER: {
            color: "#CCCCCC",
            opacity: 0.4,
            zIndex: 50
        }
    }
};
